module.exports = __webpack_public_path__ + "img/ks.0221dd32.png";